import { render } from "./AlarmsTableCalendarModal.vue?vue&type=template&id=2f79dd94&ts=true"
import script from "./AlarmsTableCalendarModal.vue?vue&type=script&lang=ts"
export * from "./AlarmsTableCalendarModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__